import { render, staticRenderFns } from "./ShowMore.vue?vue&type=template&id=f5122df0"
import script from "./ShowMore.vue?vue&type=script&lang=ts"
export * from "./ShowMore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports